<template>
  <div class="card mb-4">
    <div class="card-header">
      {{ isEditing ? $t("Edit Brand Story") : $t("Create a New Brand Story") }}
    </div>
    <div class="card-body">
      <b-form @submit.prevent="handleSubmit" :disabled="saving">
        <div class="form-row">
          <div v-if="canManageCompanies" class="form-group col-md-6">
            <label>{{ $t("Brand") }}</label>
            <b-form-select
              v-model="form.company_id"
              :options="companiesWithPlaceholder"
              value-field="id"
              text-field="name"
              required
              :class="{ 'is-invalid': errors.company_id }"
            >
            </b-form-select>
            <div v-if="errors.company_id" class="invalid-feedback">
              {{ errors.company_id[0] }}
            </div>
          </div>
          <input
            v-else
            type="hidden"
            v-model="form.company_id"
          />

          <b-form-group
            :label="$t('Position')"
            class="col-md-6"
          >
            <b-form-input
              v-model="form.position"
              required
              :class="{ 'is-invalid': errors.position }"
            ></b-form-input>
            <div v-if="errors.position" class="invalid-feedback">
              {{ errors.position[0] }}
            </div>
          </b-form-group>
        </div>

        <b-form-group :label="$t('Title')">
          <b-form-input
            v-model="form.title"
            required
            :class="{ 'is-invalid': errors.title }"
          ></b-form-input>
          <div v-if="errors.title" class="invalid-feedback">
            {{ errors.title[0] }}
          </div>
        </b-form-group>

        <b-form-group :label="$t('Text')">
          <b-form-textarea
            v-model="form.text"
            rows="4"
            required
            :class="{ 'is-invalid': errors.text }"
          ></b-form-textarea>
          <div v-if="errors.text" class="invalid-feedback">
            {{ errors.text[0] }}
          </div>
        </b-form-group>

        <b-form-group label="Files" label-class="text-capitalize">
          <file-manager
            title="Manage Files"
            resource-type="brand-story"
            :resource-id="form.id"
          ></file-manager>
        </b-form-group>

        <b-button variant="primary" type="submit" :disabled="saving">
          <b-spinner small v-if="saving"></b-spinner>
          {{ isEditing ? "Update Brand Story" : "Create Brand Story" }}
        </b-button>
      </b-form>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import FileManager from "../../Common/FileManager";

export default {
  name: "BrandStoryForm",
  components: { FileManager },
  props: {
    initialModel: {
      type: Object,
      default: null
    },
    userCompanyId: {
      type: Number,
      default: null
    },
    canManageCompanies: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        id: this.initialModel ? this.initialModel.position : "",
        company_id: this.initialModel
          ? this.initialModel.company_id
          : this.userCompanyId,
        position: this.initialModel ? this.initialModel.position : "",
        title: this.initialModel ? this.initialModel.title : "",
        text: this.initialModel ? this.initialModel.text : "",
        files: []
      },
      companies: [],
      errors: {},
      isEditing: Boolean(this.initialModel),
      saving: false,
      submitting: false
    };
  },
  computed: {
    companiesWithPlaceholder() {
      return [{ id: null, name: this.$t("Choose...") }, ...this.companies];
    }
  },
  methods: {
    async handleSubmit() {
      this.submitting = true;
      this.errors = {};

      try {
        const formData = new FormData();
        for (const key in this.form) {
          if (Array.isArray(this.form[key])) {
            this.form[key].forEach(item => formData.append(`${key}[]`, item));
          } else {
            formData.append(key, this.form[key]);
          }
        }

        const url = this.isEditing
          ? `/api/marketing/brand-stories/${this.initialModel.id}`
          : "/api/marketing/brand-stories";
        const method = this.isEditing ? "put" : "post";

        await axios({ method, url, data: formData });

        this.$bvToast.toast(
          this.isEditing
            ? "Brand story updated successfully!"
            : "Brand story created successfully!",
          {
            title: "Success",
            variant: "success",
            solid: true
          }
        );
        setTimeout(() => {
          window.location.href = "/brand-stories";
        }, 1000);
      } catch (error) {
        if (error.response && error.response.data.errors) {
          this.errors = error.response.data.errors;
        } else {
          this.$bvToast.toast("An error occurred. Please try again.", {
            title: "Error",
            variant: "danger",
            solid: true
          });
        }
      } finally {
        this.submitting = false;
      }
    },
    fetchCompanies() {
      axios
        .get("/api/clients")
        .then(response => {
          this.companies = response.data.data;
        })
        .catch(error => {});
    }
  },
  mounted() {
    this.fetchCompanies();
  }
};
</script>
